<template>

  <b-container style="flex: available">
    <b-container>
      <span style="margin-top: 10px"><br/></span>
      <b-container fluid>
        <b-container fluid>
          <b-card bg-variant="light">

            <b-form-group
                label-cols-sm="4"
                label="Business Name:"
                label-align-sm="left"
                label-for="nested-street"
            >
              <b-form-input id="nested-company-name" size="sm" v-model="businessName"
                            readonly="true"></b-form-input>
            </b-form-group>

            <b-form-group
                label-cols="4"
                label-size="md"
                label="Business Address:"
                label-align-sm="left"
                label-for="nested-street"
            >
              <b-form-input id="nested-street" size="sm" v-model="businessAddress"
                            readonly="true"></b-form-input>
            </b-form-group>
              
            <b-form-group
                label-cols="4"
                label-cols-lg="4"
                label-size="md"
                label="County*:"
                label-for="input-sm">
              <b-form-select
                  v-model="county"
                  :options="countyMap">
              </b-form-select>
            </b-form-group>

            <b-form-group
                label-cols="4"
                label-cols-lg="4"
                label-size="md"
                label="Contact Name: (Someone familiar with the winery operation and facility)"
                label-for="input-sm">
              <b-form-input id="input-sm" size="sm" v-model="contactName" readonly='true'></b-form-input>
            </b-form-group>

            <b-form-group
                label-cols="4"
                label-cols-lg="4"
                label-size="md"
                label="Contact Phone Number"
                label-for="input-sm">
              <b-form-input id="telephoneNumber" size="sm"
                            v-model="contactTelephoneNumber" readonly="true"></b-form-input>
            </b-form-group>

            <b-form-group
                label-cols="4"
                label-cols-lg="4"
                label-size="md"
                label="Email Address"
                label-for="input-sm">
              <b-form-input id="input-sm" size="sm" v-model="contactEmail" readonly="true"></b-form-input>
            </b-form-group>

            <b-form-group
                label-cols="4"
                label-cols-lg="4"
                label-size="md"
                label="Waste/Recycling/Compost Service Provider Name(s):"
                label-for="input-sm">
              <b-form-input id="input-sm" size="sm" v-model="wasteProvider"
                            readonly="true"></b-form-input>
            </b-form-group>
            <b-form-group
                label-cols="4"
                label-cols-lg="4"
                label-size="md"
                label="Water Supply Source: (Well/Municipal)"
                label-for="input-sm">
              <b-form-input id="input-sm" size="sm" v-model="waterSupplySource"
                            readonly="true"></b-form-input>
            </b-form-group>

            <b-container fluid>

              <b-form-group
                  label="Do you have a water meter that allows you to track process + offices + hospitality water use? (If no, we can assist with this).">
                <b-form-radio-group
                    v-model="trackableWaterMeter"
                    :options="yesNoOptions"
                    name="waterMeterTracking"
                    stacked
                    onclick="javascript: return false;"
                ></b-form-radio-group>
              </b-form-group>


              <b-form-group
                  label="Have you had a PG&E/CLEAResult Wine Industry Efficiency Solutions (WIES) audit in the past 5 years?">
                <b-form-radio-group
                    v-model="wiesSelected"
                    :options="yesNoOptions"
                    name="clearResult   "
                    stacked
                    onclick="javascript: return false;"
                ></b-form-radio-group>
              </b-form-group>
              <b-form-group label="Renewable Energy (Check those that apply):">
                <b-form-checkbox-group
                    v-model="renewableEnergySelected"
                    :options="renewableEnergyOptions"
                    name="renewableEnergyInstalled"
                    stacked
                    onclick="javascript: return false;"
                />
              </b-form-group>
              <b-form-group label="EV Charging Station(s):">
                <b-form-radio-group
                    v-model="evChargingStations"
                    :options="yesNoOptions"
                    name="flavour-2a"
                    stacked
                    onclick="javascript: return false;"

                />
              </b-form-group>

              <b-form-group label="Other Environmental Certification (check those that apply):">
                <b-form-checkbox-group
                    v-model="environmentalCertifications"
                    :options="environmentalCertificationsOptions"
                    name="environmentalCertifications"
                    stacked
                    onclick="javascript: return false;"
                />
              </b-form-group>
              <b-form-group label="Please indicate if you have the following features:">
                <b-form-checkbox-group
                    v-model="featuresSelected"
                    :options="featuresOptions"
                    name="flavour-2a"
                    stacked
                    onclick="javascript: return false;"
                ></b-form-checkbox-group>
              </b-form-group>
              <b-form-group label="Wastewater Treatment (Check relevant): ">
                <b-form-checkbox-group
                    v-model="wasteWaterSelected"
                    :options="wasteWaterTreatmentOptions"
                    name="flavour-2a"
                    stacked
                    readonly="true"
                ></b-form-checkbox-group>
              </b-form-group>
            </b-container>
            <div class="button-holder">
              <b-row align-h="center">
                <b-col cols="2">
                  <b-button :disabled="this.status === 'APPROVED'"
                            style="color: white; background-color: green" class="submit-button"
                            type="submit" @click="approve"
                            variant="primary">Approve
                  </b-button>
                </b-col>
                <b-col cols="2">
                  <b-button :disabled="this.status === 'APPROVED'"
                            style="color: white; background-color: green" class="submit-button"
                            type="submit" @click="reject"
                            variant="primary">Reject
                  </b-button>
                </b-col>
                <b-col cols="2">
                  <b-button style="color: white; background-color: green" class="cancel-button"
                            type="cancel" @click="cancel"
                            variant="primary">Cancel
                  </b-button>
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-container>
      </b-container>
    </b-container>
  </b-container>


</template>
<script>

export default {
  props: {
    requestId: String
  },
  data() {
    return {
      status: '',
      accountRequestId: this.requestId,
      contactName: '',
      telephoneNumber: "",
      contactTelephoneNumber: "",
      contactEmail: "",
      businessName: "",
      businessAddress: "",
      wasteProvider: "",
      waterSupplySource: "",
      wiesSelected: '',
      trackableWaterMeter: '',
      onSiteBottling: '',
      renewableEnergy: '',
      renewableEnergySelected: [],
      renewableEnergyOptions: ["Solar (at Winery)", "Solar (at Vineyard)", "Geothermal", "Wind", "Microturbine"],
      evChargingStations: '',
      environmentalCertifications: [],
      environmentalCertificationsOptions: ["CCSW", "LEED", "Organic", "Demeter Biodynamic"],
      yesNoOptions: ["Yes", "No"],
      featuresSelected: [],
      featuresOptions: ["Barrel cellar", "Caves", "On Site Bottling", "Winery Tasting Room", "Offsite Tasting Room"
        , "Onsite Kitchen", "Barrel Cleaning Machine"],
      wasteWaterSelected: [],
      wasteWaterTreatmentOptions: ["Pond(s)", "Leach", "Packaged treatment system", "Hold and Haul"],
      county: null,
      countyMap: [{text: "", value: null}, 
                  {text: "Napa", value: "28"},
                  {text: "Lake", value: "17"},
                  {text: "Marin", value: "21"},
                  {text: "Mendocino", value: "23"}, 
                  {text: "Sonoma", value: "49"}, 
                  {text: "Solano", value: "48"}],
    }
  },
  mounted() {
    this.$http.get("/account/request/" + this.accountRequestId)
        .then(
            response => {
              let theObject = response.data;
              this.status = theObject.status;
              this.contactName = theObject.contactName;
              this.telephoneNumber = theObject.telephoneNumber;
              this.contactTelephoneNumber = theObject.contactTelephoneNumber;
              this.contactEmail = theObject.contactEmail;
              this.businessName = theObject.businessName;
              this.businessAddress = theObject.businessAddress;
              this.wasteProvider = theObject.wasteProvider;
              this.waterSupplySource = theObject.waterSupplySource;
              this.wiesSelected = theObject.wiesSelected;
              this.trackableWaterMeter = theObject.trackableWaterMeter;
              this.onSiteBottling = theObject.onSiteBottling;
              this.renewableEnergy = theObject.renewableEnergy;
              this.onSiteBottling = theObject.onSiteBottling;
              this.renewableEnergy = theObject.renewableEnergy;
              this.renewableEnergySelected = theObject.renewableEnergySelected;
              this.evChargingStations = theObject.evChargingStations;
              this.environmentalCertifications = theObject.environmentalCertifications;
              this.featuresSelected = theObject.featuresSelected;
              this.wasteWaterSelected = theObject.wasteWaterSelected;
              this.wasteWaterTreatmentOptions = theObject.wasteWaterTreatmentOptions;
              this.county = theObject.county;
              console.log(response.data);
              console.log("Positive Response")
            }
        )
  },

  methods: {
    goToMyTeam: function () {
      console.log("Logging in.");
      this.$router.push({path: '/groups'});
    },
    goToAccountInfo: function () {
      console.log("Logging in.");
      this.$router.push({path: '/update-account-info'});
    },
    goToUpdatePassword: function () {
      console.log("Logging in.");
      this.$router.push({path: '/update-password'});
    },
    goToMySurvey: function () {
      console.log("Logging in.")
      this.$router.push({path: '/survey?surveyId=1'});
    },
    cancel: function () {
      this.$router.push({path: '/review-requests'});
    },
    approve: function () {
      let self = this;
      swal({
        title: "Approving...",
        text: "Please wait...",
        showConfirmButton: false,
        allowOutsideClick: false
      });
      this.$http.post('account/request/decision', {
        requestId: this.requestId,
        requestStatus: "APPROVED",
        accountType: "WINE"
      }, {
        headers: {
          'content-type': 'application/json'
        }
      })
          .then(function (response) {
            console.log(response.data);
            swal({
              title: "Account Approved!",
              showConfirmButton: false,
              timer: 1000
            });
            self.$router.push('review-requests');
          })
          .catch(function (error) {
            console.log("Something went really wrong: ", error);
            swal({
              title: "Failed!",
              showConfirmButton: false,
              timer: 1000
            });
          });

    },
    reject: function () {
      this.$http.post('account/request/decision', {
        requestId: this.requestId,
        requestStatus: "DENIED",
        accountType: "WINE"

      }, {
        headers: {
          'content-type': 'application/json'
        }
      })
          .then(function (response) {
            console.log(response.data);
          })
          .catch(function (error) {
            console.log("Something went really wrong: ", error);
          });
      this.$router.push('review-requests');
    }
  }
}
</script>
